<template>
  <card>
    <div class="list-sessions" v-if="sessions && sessions.length > 0">
      <p-button v-for="(dataRow) of sessions" :key="dataRow.sessionId" size="sm" class="btn-session"
                v-on:click="selectSession(dataRow.sessionId)">{{ dataRow.name }} {{ dataRow.sessionId }}
      </p-button>

      <ul></ul>
    </div>

    <div class="list-sessions" v-if="!sessions || sessions.length === 0">
      <h3>Sessions not found</h3>
    </div>

  </card>
</template>
<script>
import {mainStore} from "@/system/mainStore";

export default {
  name: 'session-table',
  props: {
    sessions: Array,

  },
  computed: {
  },
  methods: {
    selectSession: async function (id) {
      mainStore.selectedSession.value = id;
    },
  }
};
</script>
<style>
</style>
